<app-delete-user [userType]="userType" [displayColumns]="displayedColumns" [route]="route"></app-delete-user> 